<template>
  <el-dialog  class="toDevelop_model_dialog" top="5vh" center
              :title="'缺陷-【' + formInfo.db_id + '】' + formInfo.title" width="90%"
    :before-close="handleClose" :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form size="mini" ref="form" :rules="rules" :model="form">
      <div style="display: flex">
        <el-form-item label="任务标题" prop="domain" :label-width="formLabelWidth">
          {{ formInfo.title }}
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="任务类型" :label-width="formLabelWidth">
          {{formInfo.task_type}}
        </el-form-item>
        <el-form-item label="严重程度" label-width="185px">
          {{allSelect.BUGTASKPRIORITY[formInfo.severity]}}
        </el-form-item>
        <el-form-item label="优先级" label-width="185px">
          {{formInfo.priority}}
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="关联任务" label-width="120px">
         【{{ formInfo.related_task_id}}】{{formInfo.d_title}}
        </el-form-item>
        <el-form-item label="负责人" label-width="120px">
          {{allSelect.TEXTALLUSERSEN[formInfo.leading]}}
        </el-form-item>
        <el-form-item label="系统" label-width="120px">
          {{allSelect.TEXTALLUSERSEN[formInfo.leading]}}
        </el-form-item>
      </div>
      <div style="display: flex">
        <el-form-item label="计划开始日期" label-width="120px">
          {{ formatTimeToDate(formInfo.plt * 1, "YYYY-MM-DD HH:mm:ss") }}
        </el-form-item>
        <el-form-item label="计划完成日期" label-width="160px">
          {{ formatTimeToDate(formInfo.plet * 1, "YYYY-MM-DD HH:mm:ss") }}
        </el-form-item>
      </div>
      <el-form :model="formInfo" v-if="formInfo.db_id">
        <el-form-item class="comment_warp" label="评论" :model="formInfo" :label-width="formLabelWidth">
          <Comment  :tid="String(formInfo.db_id)" type="bug_task" />
        </el-form-item>
      </el-form>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="warning" :loading="loading.submit" @click="submit">开 始</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {
  getDevOpsSpaceBugDetailApi,
  postDevOpsSpaceUpdateBugTaskApi
} from "@/server/tops/devOps";
import { formatStrToArr, formatTimeToDate } from "@/views/tops/devOps/components/util.js"
import {mapState} from "vuex";
import Comment from '@/views/tops/devOps/producerSpace/components/comment.vue'
import {Editor} from "@/components";
import Share from "@/views/tops/devOps/producerSpace/components/bug/share.vue";
export default {
  components: {Comment },
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
  },
  data() {
    return {
      form: {
        id: ''
      },
      rules: {
      },
      formLabelWidth: '130px',
      loading: {
        submit: false,
        dialog: true
      },
    };
  },
  computed: {
    ...mapState(
        {
          // 进度条
          allSelect: (state) => state.devOps.ALLSELECT,
        }
    ),
  },
  async created() {
    await this.getBugDetailApi();
  },
  methods: {
    // 获取详情
    async getBugDetailApi() {
      const { db_id = "" } = this.formInfo || {};
      try {
        const ret = await getDevOpsSpaceBugDetailApi({
          id: db_id,
        });
        const info = ret.data[0] || {};
        this.formInfo = {
          ...this.formInfo,
          title: info.db_title,
          context: info.db_context,
          create_time: info.db_create_time,
          leading: info.db_leading,
          module: info.db_module,
          operator_context: info.db_operator_context,
          plet: info.db_plet,
          plt: info.db_plt,
          priority: info.db_priority,
          related_task_id: info.db_related_task_id,
          severity: info.db_severity,
          status: info.db_status,
          task_type: info.db_task_type,
          project_system: info.project_system,
          creator: info.db_creator,
        };
      } catch (error) {
        this.$notify({
          message: error || "获取详情失败",
          type: "error",
        });
      }
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step)
    },
    // 开始
    async submit() {
      const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
          try {
            const { db_id='', leading='' } = this.formInfo;
            let param = {
               id: db_id,
              'flag':'edit_status',
              'username' : username,
              'leading':leading,
            };
            this.loading.submit = true;
            const ret = await postDevOpsSpaceUpdateBugTaskApi(param);
            if (ret.status === 'success') {
              this.handleClose('to_be_submitted');
            } else {
              this.$notify({
                message: ret.data?.msg || "开始失败",
                type: "error",
              });
            }
          } catch (error) {
            this.$notify({
              message: 'error' || "代码报错",
              type: "error",
            });
          }
          finally {
            this.loading.submit = false;
          }

    },
    formatTimeToDate
  }
};
</script>
<style lang="scss">
.toDevelop_model_dialog {
  .el-dialog__body {
    padding-bottom: 0;
  }
}
.el-form-item--mini .el-form-item__content, .el-form-item--mini .el-form-item__label {
  line-height: 16px;
}
</style>